import { GenTableComponent } from "@app/gen-table/gen-table.component"
import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
	SimpleChange,
	ViewChild,
	booleanAttribute,
} from "@angular/core"
import {
	ConfigDefinitions,
	Followup,
	PatientFormObj,
	Test,
	PatientTestObj,
	TimeStatuses,
	ReportItemType,
	StorePatient,
	Fp_image,
} from "@app/definitions/types"
import * as moment from "moment"
import { MixedListComponent } from "@app/mixed-list/mixed-list.component"
import { PersonCommonComponent } from "@app/person-common/person-common.component"

@Component({
	selector: "app-patient",
	templateUrl: "./patient.component.html",
})
export class PatientComponent extends PersonCommonComponent {
	//inherits some fields and methods from PersonCommons!
	spinnerFieldName: string = ""

	lastMonth: string = moment
		.utc()
		.subtract(1, "month")
		.format("MMM")
		.toLowerCase()
	personType: ReportItemType = "patient" //used by PersonCommons to generalize
	isHomeMeetingOnly: boolean = false
	@Input() patient: any = null //the object that holds the field values (and is saved)
	@Input() followup: Followup = null
	@Input() isLoading: boolean = false
	@Input({ transform: booleanAttribute }) isHome: boolean = false
	@Input() timeStatus: TimeStatuses = "present"
	@Input() dayEventsLength: number = 0
	@Input() openInTests: boolean = false
	@Output() moveToOtherFollowup = new EventEmitter()
	@ViewChild("documentsTable") documentsTable: GenTableComponent
	@ViewChild("prescriptionsTable") prescriptionsTable: GenTableComponent
	@ViewChild("mixedList") mixedList: MixedListComponent

	escSub: any = null
	prevNextSub: any = null
	miscSub: any = null
	patientCollectionsSub: any = null
	isDownloading: boolean = false
	selectedDocumentsObj: any[] = []
	testsChooseAllChecked: boolean = false
	hasCheckedItems: boolean = false
	isSendingMulti: boolean = false
	patientImages: Fp_image[] = []
	isFetchingPatientImages: boolean = false

	sideItems: any[] = []
	isSendingProformaEmail: boolean = false
	isSendingProformaPhone: boolean = false
	isSendingProformaWhatsapp: boolean = false

	changeCurCenterToPatientDetails() {
		this.curCenter = this.isHome ? "patient_details" : ""
	}

	ngOnDestroy() {
		this.escSub?.unsubscribe()
		this.prevNextSub?.unsubscribe()
		this.miscSub?.unsubscribe()
		this.patientCollectionsSub?.unsubscribe()
		this.mobileChangeSub?.unsubscribe()
	}

	src: any = null

	ngOnInit() {
		this.changeSideItems()

		this.curCenter = this.isHome ? "" : ""

		this.escSub?.unsubscribe()
		this.escSub = this.eventsService.escapeKeyNonModalSubj.subscribe(() => {
			this.backToMain()
		})
		this.prevNextSub?.unsubscribe()
		this.prevNextSub = this.store.patientPrevNextSub.subscribe((res: any) => {
			if (this.patient && res.patientId == this.patient.id) {
				this.patient.last_followup = res.last_followup
				this.patient.next_followup = res.next_followup
			}
		})
		this.miscSub?.unsubscribe()
		this.miscSub = this.store.patientMiscSub.subscribe((res: any) => {
			if (this.patient && res.patient_id == this.patient.id) {
				this.store.totalFields.forEach(
					(f) => (this.patient[f] = res.patient[f])
				)
			}
		})
		this.patientCollectionsSub?.unsubscribe()
		this.patientCollectionsSub = this.store.patientCollectionsSub.subscribe(
			(res: any) => {
				if (this.patient && res.patient_id == this.patient.id) {
					this.patient[res.name] = res.collection
					switch (res.name) {
						case "mixed_list":
							if (this.mixedList) {
								this.mixedList.ngOnInit()
							}
							break
						case "documents":
							this.leftSideUpdate(res.collection, "documents")

							if (this.curCenter == "document") {
								this.documentsTable.getItems()
							}
							break
						case "finresources":
							if (this.curCenter == "invoice") {
								this.finresourceTable.getItems()
							}
							break
						case "prescriptions":
							if (this.curCenter == "medicpatient") {
								this.prescriptionsTable.getItems()
							}
							break
						case "tests":
							this.leftSideUpdate(res.collection, "tests")
							break
					}
				}
			}
		)

		//create in store and listen here to invoice table updates

		this.isMobileHandle() //PersonCommons method to handle changes in isMobile
		this.testsChooseAllChecked = false
		this.hasCheckedItems = false
		this.isSendingMulti = false

		if (this.patient) {
			this.postChange()
		}

		if (this.openInTests) {
			this.sideItemClick("test")
		}
	}
	changeSideItems() {
		this.sideItems = [
			//the items on the side column (icon comes from config, should flag (iconIsImg) if it's img. instead of icon. )
			{ name: "tasks", title: "tasks", icon: "remarks" },
			{
				name: "contactway",
				title: "contactway",
				icon: "contactway",
				iconIsImg: true,
			},
			{ name: "diagppatient", title: "diagps", icon: "diagp", iconIsImg: true },
			{
				name: "mixed_list",
				title: "mixed_list",
				icon: "mixed_list",
				iconIsImg: true,
			},
			/* {name: 'reminder', title: 'reminders', icon: 'reminder', iconIsImg: true },*/
			{ name: "invoice", title: "financial", icon: "money", iconIsImg: true },
			{
				name: "document",
				title: "documents",
				icon: "document",
				iconIsImg: true,
			},
			{ name: "test", title: "tests", icon: "test1", iconIsImg: true },
			{
				name: "medicpatient",
				title: "medics",
				icon: "medic1",
				iconIsImg: true,
			},
			{
				name: "nondrugpatient",
				title: "nondrugs",
				icon: "nondrug1",
				iconIsImg: true,
			},
			{
				name: "labtestpatient",
				title: "labtests",
				icon: "labtest",
				iconIsImg: true,
			},
			{
				name: "details",
				title: "group_details",
				icon: "group",
				iconIsImg: false,
			},
		]

		if (
			this.patient?.is_group == "yes" &&
			this.patient?.charge_mode == "by_participant"
		) {
			const areasToRemove = [
				"contactway",
				"diagppatient",
				"medicpatient",
				"nondrugpatient",
				"labtestpatient",
				"test",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}
		if (
			this.patient?.is_group == "yes" &&
			this.patient?.charge_mode == "by_group"
		) {
			const areasToRemove = [
				"contactway",
				"diagppatient",
				"medicpatient",
				"nondrugpatient",
				"labtestpatient",
				"test",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}

		if (
			this.permsService.owner_has_users &&
			!this.permsService.perms?.clinical &&
			this.sideItems.find((it) => it.name == "medicpatient")
		) {
			const areasToRemove = [
				"medicpatient",
				"nondrugpatient",
				"diagppatient",
				"labtestpatient",
				"mixed_list",
			]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}
		if (
			!this.permsService?.perms?.clinic_financial &&
			!this.permsService?.perms?.administrative &&
			this.sideItems.find((it) => it.name == "invoice")
		) {
			const areasToRemove = ["invoice"]
			this.sideItems = this.sideItems.filter(
				(it) => !areasToRemove.includes(it.name)
			)
		}

		const zonesCc = this.store.getCliniqDataOrExit()?.zones
		if (!zonesCc?.length) {
			this.sideItems = this.sideItems.filter((it) => it.name != "tasks")
		}
		if (zonesCc && zonesCc?.length) {
			const newSiteItems = []
			zonesCc.forEach((zone_id) => {
				const zoneName = this.store.searchSiteDataItem(zone_id, ["zones"])?.name
				const sideItem = this.sideItems.find((si) => si.name == zoneName)
				if (sideItem) {
					newSiteItems.push(sideItem)
				}
			})
			if (this.patient?.is_group == "yes") {
				const sideItem = this.sideItems.find((si) => si.name == "details")
				if (sideItem) {
					newSiteItems.push(sideItem)
				}
			}

			this.sideItems = [...newSiteItems]
		}
		this.load()
	}

	async ngOnChanges(changes: SimpleChange) {
		//if person changed (ex: contact) - send to load function
		if (changes[this.personType]) {
			this.postChange()
		}
		if (changes["id"]) {
			console.log(this.id)

			this.patient = await this.store.getPatient(+this.id)
			this.postChange()
		}
	}
	postChange() {
		this.load()
		this.changeSideItems()
		this.prepTestAnswers()
	}

	perpOtherSideCols() {
		const colsToUpdate = ["medicpatients", "diagppatients", "nondrugpatients"]
		colsToUpdate.forEach((colName) => {
			this.leftSideUpdate(this.patient[colName], colName)
		})
	}

	leftSideUpdate(rows: any[], patientTableToUpate: string) {
		//
		// if (["medicpatients","diagppatients","nondrugpatients"].includes(patientTableToUpate)) {
		//   rows = rows.filter(item => item.end_date == null);
		// }
		this.patient[patientTableToUpate] = [...rows]
	}

	openUploadDocumentModal() {
		this.modalService.openMulti("upload-document", {
			patient_id: this.patient.id,
			followup_id: this.followup?.id || 0,
			title: this.lang.getVal("document"),
		})
	}
	async getPatientImages() {
		if (this.isFetchingPatientImages) {
			return
		}
		this.isFetchingPatientImages = true
		const res: any = await this.apiService.post("get_fp_images", {
			patient_id: this.patient.id,
		})
		this.isFetchingPatientImages = false
		this.patientImages = res.items.map((item) =>
			this.store.createUrlForImage(item)
		)
		this.modalService.openMulti("image-gallery", {
			images: this.patientImages,
		})
	}
	addDocument() {
		this.modalService.openMulti("add-document", {
			patient_id: this.patient.id,
			title:
				this.patient.name +
				" " +
				(this.patient.id_number
					? this.lang.getVal("id_number") + " " + this.patient.id_number
					: ""),
			recipient: this.patient.name,
			resource: "patient",
			resourceId: this.patient.id,
		})
	}
	addMedicalLetter() {
		this.modalService.openMulti("add-document", {
			patient_id: this.patient.id,
			title:
				this.patient.name +
				" " +
				(this.patient.id_number
					? this.lang.getVal("id_number") + " " + this.patient.id_number
					: ""),
			recipient: this.patient.name,
			resource: "patient",
			resourceId: this.patient.id,
			followup_id: this.followup?.id || 0,
			followup: this.followup || null,
			isMedicalLetter: true,
		})
	}

	updateFinResourceIds(arrItems: any[]) {
		this.selectedDocumentsObj = arrItems
	}

	async sideItemClick(name: string) {
		if (name === "details") {
			return this.changeCurCenterToPatientDetails()
		}
		if (name == "tasks") {
			return this.modalService.openMulti("task", { patientRow: this.patient })
		}
		if (name == "document") {
			const suc = await this.store.requireDefaultSignature()
			if (!suc) {
				return
			}
		}

		this.curCenter = name
		this.updateShowColumnLocal("center")
		this.scrollToCenter()
	}
	async addPrescription() {
		let description = ""
		let initPermanentRemarks = ""
		const suc = await this.store.requireCcField(
			"prescription_signature",
			"update_prescription_signature"
		)
		if (!suc) {
			return
		}

		const retItem: any = await this.modalService.openMulti("add-prescription", {
			//open the modal with fields relevant to this personType
			patient_id: this.patient.id,
			initPermanentRemarks,
		})
		if (retItem?.patientChanged) {
			if (retItem?.patient_id_number_dec !== undefined) {
				this.patient.id_number = retItem?.patient_id_number_dec
			}
			if (retItem?.address_dec !== undefined) {
				this.patient.address = retItem?.address_dec
			}
			this.store.updatePatient(this.patient)
		}

		this.scrollTop()
	}
	async sendProforma(isBy: string = null) {
		//get the prev and next followup to be displayed in home page side menu
		this.spinnerFieldName = "isSendingProformaWhatsapp"
		if (isBy == "email") {
			this.spinnerFieldName = "isSendingProformaEmail"
		} else if (isBy == "sms") {
			this.spinnerFieldName = "isSendingProformaPhone"
		}
		this[this.spinnerFieldName] = true
		await this.store.sendProforma(this.patient, isBy)
		this[this.spinnerFieldName] = false
	}

	prepTestAnswers() {
		if (!this.patient) {
			return
		}
		this.store.getPatientWithPreppedTests(this.patient.id)
	}

	getTestHtml(test: PatientTestObj) {
		let html = ""
		if (test?.tests?.length) {
			for (let testInner of test.tests) {
				html += `
        <div>
          <h3>${testInner.name}</h3>
          ${this.getTestHtml(testInner)}
        </div>`
			}
		}
		if (test?.questions?.length) {
			for (let ques of test.questions) {
				html += `
        <div>
          <b style="display: block;">${ques.q}</b>
          ${ques.a}
        </div>`
			}
		}
		return html
	}

	async download_testfill(testRow: any) {
		testRow.isDownloading = true

		this.store.downloadToastFunc(async () => {
			const res = await this.apiService.download("download_testfill", {
				id: testRow.testfill_id,
			})
			testRow.isDownloading = false
			if (!res?.size) {
				return this.store.downloadFailedModal(50)
			}
			this.apiService.downloadFile(res, this.lang.getVal("test") + ".pdf")
		})
	}

	async openTestGraph(row: any) {
		this.modalService.openMulti("test-graph", {
			patient_id: this.patient.id,
			test_id: row.id,
		})
	}
	async openTestManage() {
		//await this.modalService.openMulti("test-manage");
		const res = await this.modalService.openMulti("tests-menu", {
			patient_id: this.patient.id,
		})
		if (res) {
			this.refreshTestfills()
		}
	}
	openTestInvites() {
		this.modalService.openMulti("patient-test-invites", {
			patient_id: this.patient.id,
		})
	}
	openTestschedules() {
		this.modalService.openMulti("testschedules", {
			patient_id: this.patient.id,
		})
	}

	async refreshTestfills() {
		const res = await this.apiService.post("get_patient_test_fills_answers", {
			patient_id: this.patient.id,
		})
		if (res?.testfills) {
			this.store.removeDecArr(res.testanswers)
			this.store.removeDecArr(res.testfills)
			this.store.updatePatientGenCollection(
				this.patient.id,
				res.testfills,
				"testfills"
			)
			this.store.updatePatientGenCollection(
				this.patient.id,
				res.testanswers,
				"testanswers"
			)

			this.prepTestAnswers()
		}
	}

	testsChooseAll() {
		this.patient.tests.forEach((t) => (t.checked = this.testsChooseAllChecked))
		this.postTestChoose()
	}
	postTestChoose() {
		this.hasCheckedItems = !!this.patient.tests.find((t) => t.checked)
	}
	async printTests() {
		const selectedItems = this.patient.tests.filter((row) => row.checked)
		if (!selectedItems.length) {
			return
		}
		for (let obj of selectedItems) {
			await this.store.downloadToastFunc(async () => {
				const res = await this.apiService.download("download_testfill", {
					id: obj.testfill_id,
				})
				if (!res?.size) {
					return this.store.downloadFailedModal(50)
				}
				this.apiService.downloadFile(res, "test-" + obj.testfill_id + ".pdf")
			})
		}
	}
	async sendTests() {
		const selectedItems = this.patient.tests.filter((row) => row.checked)
		if (!selectedItems.length) {
			return
		}
		const testfill_ids = selectedItems.map((it) => it.testfill_id)
		const contactways: any = await this.modalService.openMulti(
			"gen-table-display",
			{
				tableName: "contactways",
				filterField: "patient_id",
				filterFieldValue: this.patient.id,
				fieldNameInItemToDisplay: "contactway",
				isCheckItems: true,
				...this.store.phoneEmailValidationAttrs(),
			}
		)
		if (!contactways?.length) {
			return
		}
		const contactway_ids = contactways.map((row) => row.id)
		this.isSendingMulti = true
		const res: any = await this.apiService.post("email_tests", {
			testfill_ids,
			contactway_ids,
		})
		this.modalService.openToast(this.lang.getVal("sent_to"))
		this.isSendingMulti = false
	}
}
